export default "__VITE_ASSET__Bcc2Qn2A__"